module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "d-flex align-items-center mb-2",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field has-addons w-100p"
  }, [_c('div', {
    staticClass: "control is-medium grow-1",
    class: _vm.loading && 'is-loading'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proxyValue),
      expression: "proxyValue"
    }],
    staticClass: "input is-medium",
    attrs: {
      "autocomplete": "false",
      "id": "search-box",
      "autofocus": "",
      "placeholder": "Type a name"
    },
    domProps: {
      "value": (_vm.proxyValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proxyValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control is-medium"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    class: _vm.loading && 'is-loading',
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Search\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-01e40bb1"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBox.vue
// module id = 969
// module chunks = 0